/* eslint-disable camelcase */

import React from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import BulmaContainer from 'react-bulma-components/lib/components/container';

import { BlogFragment } from '../fragments';

import { MainLayout } from '../layouts';
import { TagNav, BlogPost } from '../components/Blog';

export const query = graphql`
  query BlogBySlug($uid: String!) {
    prismic {
      blog(lang: "en-us", uid: $uid) {
        ...BlogFragment
      }
    }
  }
`;

const shortenString = str => str.substring(0, 200);

const BlogPostPage = ({ data: { prismic } }) => {
  const postData = prismic.blog;
  let setMetaDescription;

  if (postData && postData.blog_meta_description) {
    setMetaDescription = postData.blog_meta_description;
  } else if (postData && postData.blog_post_content[0].text) {
    setMetaDescription = shortenString(postData.blog_post_content[0].text);
  } else {
    setMetaDescription = 'DigitalOcean';
  }

  return (
    <MainLayout layout="blog">
      <Helmet>
        <title>
          {postData && postData.blog_meta_title
            ? `DigitalOcean Blog | ${postData.blog_meta_title}`
            : 'DigitalOcean Blog'}
        </title>
        <link
          rel="canonical"
          href={
            postData && postData._meta.uid
              ? `https://www.digitalocean.com/blog/${postData._meta.uid}/`
              : 'https://www.digitalocean.com/blog/'
          }
        />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@digitalocean" />
        <meta name="twitter:creator" content="@digitalocean" />
        <meta
          name="twitter:title"
          content={postData && postData.blog_meta_title ? postData.blog_meta_title : 'DigitalOcean Blog'}
        />
        <meta
          name="twitter:image"
          property={
            postData && postData.blog_header_image
              ? postData.blog_header_image.url
              : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'
          }
        />
        <meta name="twitter:description" content={setMetaDescription} />
        <meta property="og:type" content="blog" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="600" />
        {}
        <meta property="og:description" content={setMetaDescription} />
        <meta
          property="og:title"
          content={postData && postData.blog_meta_title ? postData.blog_meta_title : 'DigitalOcean Blog'}
        />
        <meta
          property="og:image"
          content={
            postData && postData.blog_header_image
              ? postData.blog_header_image.url
              : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'
          }
        />
        <meta
          property="og:url"
          content={
            postData && postData._meta.uid
              ? `https://www.digitalocean.com/blog/${postData._meta.uid}/`
              : 'https://www.digitalocean.com/blog/'
          }
        />
      </Helmet>

      <div className="blog-tag-container">
        {TagNav('', 'hideOnMobile')}
        <BulmaContainer>
          {postData && postData._meta.uid ? BlogPost(postData, postData._meta.uid) : null}
        </BulmaContainer>
      </div>
    </MainLayout>
  );
};
export default BlogPostPage;

BlogPostPage.propTypes = {
  data: PropTypes.object.isRequired,
};
